module.exports = __webpack_public_path__ + "assets/img/btn-view-04413e85.png";